import React, { useEffect, useState } from "react";
import TabsPanel from "./tabs/tabsPanel";
import {
  GetCoreInformationResponse,
  ReferenceKeyRequest,
} from "../../models/loan.model";
import { useMutation } from "react-query";
import { GetLoanInformation } from "../../services/loan.service";
import { ApiResultModel } from "../../models/common.model";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import FacilityFileDetail from "./tabs/facilityFileDetail";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
function _detailPage(props: any) {
  return (
    <div
      // className="cardDetail "
      style={{ background: "#F9F6F7", padding: "2px !important" }}
    >
      <div style={{ background: "#F9F6F7" }}>
        <Grid
          container
          xs={12}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={{ backgroundColor: "#F9F6F7" }}
        >
          <Grid
            item
            xs={4}
            sm={6}
            md={4}
            style={{ alignItems: "center", display: "grid" }}
          >
            <Typography className=" " style={{ marginLeft: "2vh" }}>
              <AccountCircleIcon
                style={{ width: "46px", height: "46px", color: "#9AAFC4" }}
              />
              <span className="detailPageTitle" style={{ marginRight: "1vh" }}>
                {props.requestDetail?.customerFullName}
              </span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sm={6}
            md={4}
            style={{ alignItems: "center", display: "grid" }}
          >
            <Typography className=" " style={{ marginLeft: "2vh" }}>
              <b className="detailPageTitle">کد ملی: </b>
              <span className="detailPageTitle">
                {props.requestDetail?.customerNationalCode}
              </span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sm={6}
            md={4}
            style={{ alignItems: "center", display: "grid" }}
          >
            <Typography
              className=" "
              style={{
                marginLeft: "2vh",
                whiteSpace: "nowrap",
              }}
            >
              <b className="detailPageTitle"> آخرین وضعیت: </b>
              <span className="detailPageTitle">
                {props.requestDetail?.loanRequestStatusTitle}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default function DetailLoanReadOnly() {
  const [dataGetLoanInformation, setDataGetLoanInformation] = useState<
    GetCoreInformationResponse
  >();
  const history = useHistory<{
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const refKey_history =
    history.location.state !== undefined
      ? history.location.state.id
      : undefined;
  const requestPanelTabs = new ReferenceKeyRequest();
  requestPanelTabs.referenceKey = String(refKey_history);
  const {
    mutateAsync: GetLoanInformationMutation,
    isLoading: isMutatinCore,
  } = useMutation(GetLoanInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data.isSuccess) {
        setDataGetLoanInformation(data.data);
      }
    },
  });
  useEffect(() => {
    refKey_history
      ? GetLoanInformationMutation(requestPanelTabs)
      : history.push("/loan/loan-list");
  }, []);
  const child = (
    <_detailPage
      id={refKey_history}
      requestDetail={dataGetLoanInformation?.loanRequestInfo}
    />
  );
  if (isMutatinCore) {
    return (
      <div>
        <Backdrop
          hidden={false}
          open={true}
          sx={{ color: "#fff", zIndex: () => 1 }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }
  return (
    <div>
      {dataGetLoanInformation && (
        <>
          <FacilityFileDetail
            child={child}
            requestDetail={dataGetLoanInformation?.loanRequestInfo}
          />
          <TabsPanel panelTabs={dataGetLoanInformation} />
        </>
      )}
    </div>
  );
}
